export default __webpack_public_path__ + "static/media/PaidDefault.9fb53efe.svg";